
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  elementNextbutton: {
    id: "ElementNext.button",
    defaultMessage: "Next",
  },
});

export default MESSAGES;